@use "../../../../shared/scss" as *;

:host {
  display: block;
  padding-inline: 10%;
  padding-block-start: p-px-to-rem(10px);

  @include pds-media-query-min("s") {
    margin-block-start: (-$pds-spacing-static-medium);
    padding-block-start: 0;
  }

  @include pds-media-query-max("s") {
    padding-inline: p-px-to-rem(27px);
  }

  .models-item {
    max-inline-size: $max-model-width;
    inline-size: 100%;
  }

  .models-teaser {
    @include pds-media-query-min("s") {
      margin-block-end: $pds-spacing-static-medium;
    }

    &:hover img {
      scale: 1.1 !important;
    }

    & a {
      display: grid;
      border-radius: p-px-to-rem(12px);
      overflow: hidden;
      text-decoration: none;
      color: $pds-theme-light-background-base;

      & > * {
        grid-column: 1 / -1;
        grid-row: 1 / -1;
        align-self: end;
      }

      & .teaser-text {
        isolation: isolate;
        display: flex;
        align-items: end;
        justify-content: space-between;
        padding-block-end: p-px-to-rem(20px);
        padding-inline: p-px-to-rem(20px);
      }

      & img {
        aspect-ratio: 352 / 220;
        object-fit: cover;
        border-radius: inherit;
        inline-size: 100%;
        scale: 1;
        transition: scale $pds-motion-duration-short $pds-motion-easing-base;
      }

      & phn-p-icon {
        filter: invert(1);
      }
    }
  }

  button {
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  ul {
    padding-block: 0;
    padding-inline: 0;
    display: grid;
    place-items: center;
    gap: $pds-spacing-static-small + $pds-spacing-static-x-small;
    margin-block: 0;

    @include pds-media-query-min("s") {
      gap: 1px;
    }

    & li {
      list-style: none;
    }
  }

  .skeleton-headline {
    inline-size: auto;
    block-size: p-px-to-rem(50px);
    background: $pds-theme-light-contrast-low;
    border-radius: 4px;
  }

  .series {
    display: flex;
    justify-content: center;
    inline-size: 100%;
    // calculated to include the 4px focus padding
    margin-block: 0;
    margin-inline: 0;

    phn-nd-menu-item {
      inline-size: 100%;
    }

    .model-area-hidden {
      display: none;
    }

    &:focus-visible {
      outline-color: $pds-theme-light-state-focus;
    }
  }
}
